/**
 * @author lihh
 * @description 请求都是共同服务 比如性别  求职状态等 表示hpc请求居多
 */
// 导入axios
import request from '@/utils/request';
// 导出共同模块
import {
  Message
} from 'view-design';
import * as qiniu from 'qiniu-js';
import CommonUtil from '@/assets/js/CommonUtil';
const Utils = new CommonUtil();

import {
  SERVICE_TYPE_HPC,
  SERVICE_TYPE_HPO,
  SERVICE_TYPE_HPM
} from '@/utils/define';

/**
 * @author lihh
 * @description 获取手机号
 * @param {@} data 表示数据
 */
export function getPhone(data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;

  return request({
    url: `/${SERVICE_TYPE_HPM}/User/GetPhoneCode`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 微信扫码绑定手机号
 * @param code 表示验证code
 */
export function stuWeChatLogin(code = '') {
  return request({
    url: `/${SERVICE_TYPE_HPO}/Wechat/stuWeChatLogin`,
    method: 'POST',
    data: {code}
  });
}

/**
 * @author lihh
 * @description 短信登录发送验证码 或微信绑定手机号验证码
 * @param {*} mobile 
 */
export function bindMobileNumber(mobile = '') {
  return request({
    url: `/${SERVICE_TYPE_HPO}/Oauth/bindMobileNumber`,
    method: 'POST',
    data: {mobile, side: 'stu', 'tokenNeed': '1'}
  });
}

/**
 * @author lihh
 * @description 微信扫码登录 绑定手机号
 */
export function perfectWeChatMobile(data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;

  return request({
    url: `/${SERVICE_TYPE_HPO}/Oauth/perfectWeChatMobile`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 双选会-获取热门城市
 * @param {@} data 表示数据
 */
export function GetDoubleCities(data = {}) {

  return request({
    url: `/${SERVICE_TYPE_HPM}/DoubleEle/GetDoubleCities`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 双选会-获取行业
 * @param {@} data 表示数据
 */
export function GetDoubleIndustry(data = {}) {

  return request({
    url: `/${SERVICE_TYPE_HPM}/DoubleEle/GetDoubleIndustry`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 双选会-获取区域
 * @param {@} data 表示数据
 */
export function region(data = {}) {

  return request({
    url: `/${SERVICE_TYPE_HPC}/EnumData/region`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 进行token验证
 * @param {@} token 表示token
 */
export function tokenCheck(token = '') {

  return request({
    url: `/${SERVICE_TYPE_HPM}/ComUser/VerifyToken`,
    method: 'POST',
    data: {token, "tokenCheck": 'skip'}
  });
}

/**
 * @author lihh
 * @description 获取图片验证码
 * @param {*} data
 * @param mobile 表示手机号 
 */
export function getPicCode( mobile = '', data = {}) {
  return request({
    url: `/${SERVICE_TYPE_HPO}/VerCode/captchaImage${mobile === '' ? '' : `?mobile=${mobile}`}`,
    method: 'Get',
    data
  });
}

/**
 * @author lihh
 * @description 获取所有的省市
 * @param {*} data 
 */
export function getAllAddress(data = {}) {

  return request({
    url: `/${SERVICE_TYPE_HPC}/RetrievalData/getAllAddress`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 上传用户头像
 * @param {*} data 
 */
export function uploadAvatar(data = {}) {

  // 表示需要token
  data['tokenNeed'] = 1;

  return request({
    url: `/${SERVICE_TYPE_HPM}/User/UploadAvatar`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 获取职位
 * @param {*} data 
 */
export function getPosions(data = {}) {

  return request({
    url: `/${SERVICE_TYPE_HPC}/RetrievalData/PGetPosions`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 获取行业
 * @param {*} data 
 */
export function getIndustries(data = {}) {

  return request({
    url: `/${SERVICE_TYPE_HPC}/RetrievalData/PGetIndustries`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 获取专业类别
 * @param {*} data 
 */
export function getProfessionalType(data = {}) {

  return request({
    url: `/${SERVICE_TYPE_HPC}/RetrievalData/getProfessionalType`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 获取专业类别(职位搜索用)
 * @param {*} data 
 */
export function getProfessional(data = {}) {

  return request({
    url: `/${SERVICE_TYPE_HPC}/RetrievalData/getProfessional`,
    method: 'POST',
    data
  });
}

/**
 * @author wangl
 * @description 共同服务 获取举报原因
 */
export function getStucomplainReason() {
  return commonReq("hp_stucomplain_reason");
}

/**
 * @author lihh
 * @description 共同服务 获取政治面貌
 */
export function getPoliticalOutlook() {
  return commonReq("hp_political_outlook");
}

/**
 * @author lvcx 
 * @description 单聊选择不合适列表
 * @param {@} 
 */

 export function stuimproper() {
  return commonReq("hp_stuimproper_reason");
}

/**
 * @author lihh
 * @description 共同服务 转正机会
 */
export function getBecomeChance() {
  return commonReq("hp_become_chance");
}

/**
 * @author lihh
 * @description 共同服务 获取举报信息
 */
export function getReportInfo() {
  return commonReq("hp_report_type");
}

/**
 * @author lihh
 * @description 共同服务 获取目前状态
 */
export function getCurrentStatus() {
  return commonReq("hp_current_status");
}

/**
 * @author lihh
 * @description 共同服务 获取到岗时间
 */
export function getArrivalTime() {
  return commonReq("hp_arrival_time");
}

/**
 * @author lihh
 * @description 共同服务-查询性别
 */
export function getSex() {
  return commonReq("hp_sex");
}

/**
 * @author lihh
 * @description 共同服务-查询性别
 */
export function getMarriag() {
  return commonReq("hp_marriage");
}

/**
 * @author lihh
 * @description 共同服务-表示熟练程度
 */
export function skillMastery() {
  return commonReq("hp_skill_mastery");
}

/**
 * @author lihh
 * @description 共同服务-表示语种
 */
export function getLanguage() {
  return commonReq("hp_language");
}

/**
 * @author lihh
 * @description 共同服务-目前状态
 */
export function getJobQuality() {
  return commonReq("hp_job_quality");
}

export function getJobQualityNew() {
  return commonReq("hp_experience_requirement");
}

// 企业性质
export function getNatureEnterprise() {
  return commonReq("hp_nature_of_enterprise");
}

/**
 * @author lihh
 * @description 共同服务-企业规模
 */
export function getCompyScale() {
  return commonReq("hp_enterprise_scale");
}

/**
 * @author lihh
 * @description 共同服务-获取学历
 */
export function getJobSeekerEducation() {
  return commonReq("hp_Job_seeker_education");
}

/**
 * @author lihh
 * @description 共同服务-获取学历(全职 实习列表用)
 */
export function getAcademicRequirements() {
  return commonReq("hp_academic_requirements");
}

/**
 * @author lvcx 
 * @description 取消面试原因列表
 * @param {@} 
 */

export function Nointerview() {
  return commonReq("hp_nointerview_reason");
}

/**
 * @author lvcx 
 * @description 同意或拒绝面试
 */

export function InterState(data = {}) {
  data['tokenNeed'] = 1;
  return request({
    url: `/${SERVICE_TYPE_HPM}/Operate/InterState`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 共同服务提取
 * @param {*} type 
 */
function commonReq(type = "") {
  return request({
    url: `/${SERVICE_TYPE_HPC}/EnumData/getEnumById?type=${type}`,
    method: 'POST',
    data: {}
  });
}

/**
 * @author lihh
 * @description 获取七牛云token
 * @param {*} data 
 */
export function getQiNiuToken(data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;

  return request({
    url: `/${SERVICE_TYPE_HPM}/Resume/GetQiNiuToken`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 获取图片上传相关的token
 * @param {*} data 
 */
export function getQiNiuTokenImg(data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;

  return request({
    url: `/${SERVICE_TYPE_HPM}/Job/GetQiNiuTokenImg`,
    method: 'POST',
    data
  });
}

/**
 * @author lihh
 * @description 查询数据库 部分数据是否更新(专业，地区等)
 * @param {*} data
 */
export function getIfFresh() {
  return request({
    url: `/${SERVICE_TYPE_HPC}/RetrievalData/getIfFresh`,
    method: 'POST',
    data: {}
  });
}

/**
 * @author wangl
 * @description 获取打招呼语
 */
export function getCommonWords(data = {}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;
    return request({
        url: `/${SERVICE_TYPE_HPO}/HX/getCommonWords`,
        method: 'POST',
        data
    });
}

/**
 * @author wangl
 * @description 设置打招呼语
 */
export function setCommonWords(id = '',data={}) {

  // 表示需要toekn
  data['tokenNeed'] = 1;
    return request({
        url: `/${SERVICE_TYPE_HPO}/HX/setCommonWords?id=${id}`,
        method: 'POST',
        data
    });
}

/**
 * @author lihh
 * @description 七牛上传文件或是视频
 * @param type 2 表示文件 1表示视频 1和2走同一个token请求 3是单独token请求
 * @param files 表示文件流
 * @param suffix 上传文件后缀
 * @param next 分布式上传过程
 * @param error 失败回调
 * @param succ 成功回调
 */
export function _qiNiuUpload(type = '2', files, suffix = 'mp4', next, succ, error) {

  // 对调用方法进行判断
  const fns = type === '3' ? getQiNiuTokenImg : getQiNiuToken;

  fns(type === '3' ? {} : {type}).then(res => {

      // 判断请求是否成功
      if (res.code !== '200') {

        Message.error(res.msg);
        return false;
      }

      // 设置资源名称
      let key = Utils._getuuId() + '_' + Utils._getuuId() + '.' + suffix;
      // 定义配置文件
      let config = {
          useCdnDomain: true,
          region: qiniu.region.z0
      }
      // 约束类型
      let putExtra = {
          fname: name,
          params: {},
          mimeType: null
      };

      // 进行上传
      let observable = qiniu.upload(files, key, res.data, putExtra, config);
      // 回调监听
      observable.subscribe({
          next: (result) => {

            next(result);
          },
          error: (errResult) => {

              // 失败报错信息
              console.log(errResult)
          },
          complete: (result) => {
              
              succ(result);
          }
      })
  });
}


// WEBPACK FOOTER //
// ./src/api/request/commonService.js